import React from "react";

export default function Terms() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-slate-800">
      <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
      <p className="text-sm text-slate-500 mb-8">
        Last updated: 20-01-2026
      </p>

      <section className="space-y-6">
        <div>
          <h2 className="text-xl font-semibold mb-2">1. About ImportDocs</h2>
          <p>
            ImportDocs is a cloud-based platform that helps importers manage,
            store, and share shipping and import-related documents.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">2. Accounts</h2>
          <p>
            You are responsible for maintaining the security of your account
            and all activity under it.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">3. Uploaded Documents</h2>
          <p>
            You retain ownership of all documents you upload. ImportDocs does
            not verify or validate document accuracy.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">4. Vendor Links</h2>
          <p>
            Vendor links allow suppliers to upload documents only. You are
            responsible for reviewing supplier-submitted files.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">5. Availability</h2>
          <p>
            We aim to provide reliable service but do not guarantee uninterrupted
            access. You should maintain your own backups.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">6. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, ImportDocs is not liable for
            shipment delays, customs issues, or indirect losses.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">7. Governing Law</h2>
          <p>
            These terms are governed by the laws of Australia.
          </p>
        </div>
      </section>
    </div>
  );
}
